'use client'

// Применяет размер текста и контраст из localStorage при загрузке любой
// страницы (lib/display-prefs.ts). Монтируется один раз в app/layout.tsx.
import { useEffect } from 'react'
import { applyDisplayPrefs } from '@/lib/display-prefs'

export function DisplayPrefs() {
  useEffect(() => {
    applyDisplayPrefs()
  }, [])
  return null
}
